"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { trackGTMPageView } from "./utils";

type Props = {
	gtmId: string;
};

export function GoogleTagManagerPageView({ gtmId }: Props) {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	// Track pageview on route change
	useEffect(() => {
		const url = pathname + searchParams.toString();

		trackGTMPageView(url, gtmId);
	}, [pathname, searchParams, gtmId]);

	return null;
}
